import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-grid-cards-without-frame',
  templateUrl: './grid-cards-without-frame.component.html',
  styleUrls: ['./grid-cards-without-frame.component.css'],
})
export class GridCardsWithoutFrameComponent {
  @Input() data!: any;
  @Input() fileName!: string;
  @Input() language!: string;

  getDetailsUrl(object: any): string {
    return `/${this.language}/details/${this.fileName}/${object.title
      .replaceAll(' ', '-')
      .toLowerCase()}`;
  }
}
